// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1BHGP","selects":"Documents_selects__15bzN"};